import { DocumentReference } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";
import { isPageRef } from "./isPageRef";

/**
 * Type guard to check if a value is a DocumentReference.
 *
 * @param obj - The value to check.
 * @returns True if the value is a DocumentReference.
 */
export const isDocumentReference = (obj: unknown): obj is DocumentReference => {
  if (!isObjectRecord(obj)) return false;

  if (typeof obj.referenceDocumentId !== "string") return false;

  if (obj.pageRefs !== undefined) {
    if (!Array.isArray(obj.pageRefs)) return false;
    if (obj.pageRefs.some((pageRef) => !isPageRef(pageRef))) return false;
  }

  return true;
};
